function parseReadingDate(reading) {
  const raw = reading?.data_local || reading?.timestamp || reading?.created_at;
  if (!raw) return null;
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function resolveSensorHistoryRange(period, startDate, endDate, now = new Date()) {
  const referenceEnd = new Date(now);
  if (Number.isNaN(referenceEnd.getTime())) return null;

  if (period === '24h') {
    return {
      start: new Date(referenceEnd.getTime() - 24 * 60 * 60 * 1000),
      end: referenceEnd,
    };
  }

  if (!startDate || !endDate) return null;
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T23:59:59`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;
  return { start, end };
}

export function filterSensorReadingsByPeriod(readings = [], startDate, endDate) {
  if (!startDate || !endDate) return [];
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T23:59:59.999`);

  return readings
    .filter(reading => {
      const date = parseReadingDate(reading);
      return date && date >= start && date <= end;
    })
    .sort((left, right) => parseReadingDate(left) - parseReadingDate(right));
}

function numericValues(readings, field) {
  return readings
    .map(reading => Number(reading?.[field]))
    .filter(Number.isFinite);
}

function average(values) {
  return values.length ? values.reduce((sum, value) => sum + value, 0) / values.length : null;
}

export function aggregateMeteorologicalReadingsByDay(readings = []) {
  const grouped = readings.reduce((days, reading) => {
    const date = parseReadingDate(reading);
    if (!date) return days;
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    if (!days.has(key)) days.set(key, []);
    days.get(key).push(reading);
    return days;
  }, new Map());

  return Array.from(grouped.entries())
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([data_local, dayReadings]) => {
      const temperatures = numericValues(dayReadings, 'temp_c');
      const humidity = numericValues(dayReadings, 'rh_perc');
      const rainfall = numericValues(dayReadings, 'rain_mm');

      return {
        data_local,
        temp_media: average(temperatures),
        temp_max: temperatures.length ? Math.max(...temperatures) : null,
        temp_min: temperatures.length ? Math.min(...temperatures) : null,
        chuva_total: rainfall.length ? rainfall.reduce((sum, value) => sum + value, 0) : 0,
        rh_perc_media: average(humidity),
        leituras: dayReadings.length,
      };
    });
}
